<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="班组名称">
              <a-input placeholder="请输入班组名称" v-model="queryParam.groupName"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
      <a-button type="primary" icon="download" @click="handleExportXls('用水企业班组')">导出</a-button>
      <!-- 高级查询区域 -->
      <j-super-query :fieldList="superFieldList" ref="superQueryModal" @handleSuperQuery="handleSuperQuery"></j-super-query>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>删除</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">详情</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>

    <wf-consumer-corp-group-modal ref="modalForm" @ok="modalFormOk"></wf-consumer-corp-group-modal>
  </a-card>
</template>

<script>
  import { getAction } from '@/api/manage'
  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import WfConsumerCorpGroupModal from './modules/WfConsumerCorpGroupModal'
  import {filterMultiDictText} from '@/components/dict/JDictSelectUtil'

  export default {
    name: 'WfConsumerCorpGroupList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      WfConsumerCorpGroupModal
    },
    props: {
      //表单禁用
      filter: {
        type: Object,
        default: () => { },
      }
    },
    watch: {
      filter: {
        handler () {
          this.searchQuery();
        },
        deep: true
      }
    },
    data () {
      return {
        description: '用水企业班组管理页面',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:'班组名称',
            align:"center",
            dataIndex: 'groupName'
          },
          {
            title:'企业',
            align:"center",
            dataIndex: 'corpId_dictText'
          },
          {
            title:'备注',
            align:"center",
            dataIndex: 'remark'
          },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/wf/corpGroup/list",
          delete: "/wf/corpGroup/delete",
          deleteBatch: "/wf/corpGroup/deleteBatch",
          exportXlsUrl: "/wf/corpGroup/exportXls",
          importExcelUrl: "wf/corpGroup/importExcel",
          
        },
        localFilter: {},
        dictOptions:{},
        superFieldList:[],
        disableMixinCreated: true,
      }
    },
    created() {
      this.getSuperFieldList();

      //如果是企业管理员登录，赋值corpId, 值为userInfo.corpIds
      if(!!this.userInfo.thirdAccount){
        this.localFilter = {
          corpId: this.userInfo.corpIds
        }
      }

      if (this.filter?.corpId || this.localFilter?.corpId) {
        this.columns = this.columns.filter(col => col.dataIndex !== 'corpId_dictText')
        //写入queryParam，查询和导出都增加过滤条件
        this.queryParam.corpId = this.queryParam.corpId = this.filter?.corpId || this.localFilter?.corpId;
      }

      // 在 localFilter 设置完成后调用 loadData
      this.$nextTick(() => {
        this.loadData(1);
      });
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      userInfo() {
        return this.$store.getters.userInfo
      }
    },
    methods: {
      loadData (arg) {
        if (!this.url.list) {
          this.$message.error('请设置url.list属性!')
          return
        }
        // 加载数据 若传入参数1则加载第一页的内容
        if (arg === 1) {
          this.ipagination.current = 1
        }
        var params = this.getQueryParams()// 查询条件
        this.loading = true;
        // 合并 localFilter 和 filter
        const mergedFilter = { ...this.localFilter, ...this.filter };
        Object.assign(params, mergedFilter);

        console.log('loadData params:', params); // 添加日志以检查参数
        getAction(this.url.list, params).then((res) => {
          if (res.success) {
            this.dataSource = res.result.records || res.result
            if (res.result.total) {
              this.ipagination.total = res.result.total
            } else {
              this.ipagination.total = 0
            }
          }
        }).finally(() => {
          this.loading = false
        })
      },
      initDictConfig(){
      },
      getSuperFieldList(){
        let fieldList=[];
        fieldList.push({type:'string',value:'groupName',text:'班组名称',dictCode:''})
        fieldList.push({type:'string',value:'corpId',text:'企业',dictCode:'`iwt-wf`.wf_consumer_corp,corp_name,id'})
        fieldList.push({type:'string',value:'remark',text:'备注',dictCode:''})
        this.superFieldList = fieldList
      }
    }
  }
</script>
<style scoped>

  @import '~@assets/less/common.less';

</style>